import { gql } from "@apollo/client";

export const TOP_NAV_QUERY = gql`
  query TopNav {
    viewer {
      id
      user {
        id
        orgs {
          edges {
            node {
              id
              name
              userPerson {
                __typename
                ... on GraphEntityError {
                  message
                }
                ... on Person {
                  id
                  profile {
                    givenName
                    familyName
                    externalImageUrl
                  }
                }
              }
              workingGroups {
                edges {
                  node {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
